import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const QueueFamilyForInviteMutation = graphql.persisted(
  "QueueFamilyForInvite",
  graphql(`
    mutation QueueFamilyForInvite($familyEnrollmentId: ID!) {
      queueFamilyForInvite(input: {familyEnrollmentId: $familyEnrollmentId}) {
        familyEnrollment {
          id
          state
          inviteStatus
          canQueueForInvite
          canSendInvite
          queuedAt
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { QueueFamilyForInviteMutation };

export function useQueueFamilyForInvite() {
  return useMutation(QueueFamilyForInviteMutation);
}
